// ExamAdmin.js
import { useState, useEffect, useRef } from "react";

// Helper component for managing individual video elements
const VideoFeed = ({ id, stream }) => { // Expect a single stream object now
  const videoRef = useRef(null);

  useEffect(() => {
    // Assign the stream directly to the srcObject
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]); // Dependency only on the stream object

  return (
    <div>
      <h3>Student: {id}</h3>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        controls={true}
        style={{ width: "400px", border: "1px solid black" }}
      />
    </div>
  );
};


function ExamAdmin() {
  // State now maps studentId -> MediaStream object (not an array of streams)
  const [streams, setStreams] = useState({});
  const socket = useRef(new WebSocket("ws://192.168.40.1:5000")).current;
  const peers = useRef({}); // studentId -> RTCPeerConnection

  useEffect(() => {
    socket.onopen = () => {
      console.log("Admin connected");
      socket.send(JSON.stringify({ role: "admin" }));
    };

    socket.onmessage = async (event) => {
      const msg = JSON.parse(event.data);

      if (msg.offer) {
        const studentId = msg.studentId;
        
        if (peers.current[studentId] && peers.current[studentId].signalingState !== 'closed') {
           console.log(`Peer connection for ${studentId} already exists/is processing. Ignoring offer.`);
           return; 
        }
        
        const peer = new RTCPeerConnection();
        peers.current[studentId] = peer;

        // CRITICAL: Attach ontrack *before* setting remote description
        peer.ontrack = (e) => {
          console.log(`Track received for student ${studentId}. Kind: ${e.track.kind}`);
          // e.streams[0] holds the MediaStream object we need
          if (e.track.kind === 'video') {
             setStreams(prev => ({ ...prev, [studentId]: e.streams[0] }));
          }
        };
        
        peer.onicecandidate = (event) => {
          if (event.candidate) {
            socket.send(JSON.stringify({
              candidate: event.candidate,
              toStudentId: studentId
            }));
          }
        };

        await peer.setRemoteDescription(new RTCSessionDescription(msg.offer));
        
        const answer = await peer.createAnswer();
        await peer.setLocalDescription(answer);

        socket.send(JSON.stringify({
          answer,
          toStudentId: studentId
        }));
      }
      
      // ... (ICE candidate handling remains the same as previous response) ...
      if (msg.candidate && msg.from) {
        const peer = peers.current[msg.from];
        if (peer && peer.remoteDescription) {
          try {
            await peer.addIceCandidate(new RTCIceCandidate(msg.candidate));
          } catch (e) {
            console.error("Error adding ICE candidate on admin side:", e);
          }
        }
      }
    };
    
    // Cleanup function when component unmounts
    return () => {
        socket.close();
        for (const id in peers.current) {
            if (peers.current[id]) {
                peers.current[id].close();
            }
        }
    }

  }, [socket]);

  return (
    <div>
      <h1>Admin Page</h1>
      {Object.keys(streams).map((id) => (
        // Pass the specific MediaStream object to the component
        <VideoFeed key={id} id={id} stream={streams[id]} />
      ))}
    </div>
  );
}

export default ExamAdmin;
